import React from 'react'
import { View, Image } from 'react-native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { PoweredByBluetape } from './PoweredByBluetape'
import { useResponsive } from '../../utils/hooks'
import RootStore from '../../store'

export const getCoBrandingHeaderHeight = (sm: boolean): number => (sm ? 80 : 54)

export const CoBrandingHeader = () => {
  const { sm } = useResponsive()
  const { branding } = RootStore
  return branding ? (
    <View
      style={composeStyle(
        {
          flexDirection: 'row',
          width: '100%',
          height: getCoBrandingHeaderHeight(sm),
          backgroundColor: 'white',
          justifyContent: 'space-between',
          paddingVertical: 16,
          paddingHorizontal: 40,
          marginBottom: 2,
          borderColor: '#E6EBEE',
          borderWidth: 1,
        },
        !sm && { paddingVertical: 13, paddingHorizontal: 16 },
      )}
      testID="whitelabelHeader"
    >
      <Image
        source={{ uri: branding?.logoUrl }}
        style={{ width: sm ? 151 : 83, height: sm ? 47 : 26 }}
        resizeMode="contain"
      />
      <PoweredByBluetape />
    </View>
  ) : null
}
